import React from 'react'
import classNames from 'classnames'

interface FormFieldProps {
  fullWidth?: boolean
  smallerWidthFields?: boolean
  intlBottomForm?: boolean
  hidden?: boolean
  classes?: string
  children: any
}

const FormField = ({
  fullWidth = false,
  smallerWidthFields = false,
  intlBottomForm = false,
  hidden,
  classes,
  children
}: FormFieldProps) => {
  const formFieldClass = classNames(
    'field-wrapper relative flex flex-shrink basis-3/5 grow mr-0 mb-6',
    classes,
    {
      'flex-nowrap': !fullWidth,
      '[@media(min-width:576px)]:w-[calc(50%-1px)] [@media(min-width:576px)]:inline-flex':
        !fullWidth && !intlBottomForm,
      '[@media(min-width:992px)]:w-[calc(50%-1px)] [@media(min-width:992px)]:inline-flex':
        !fullWidth && intlBottomForm,
      'flex-wrap w-auto': fullWidth,
      hidden: hidden
    }
  )

  return <div className={formFieldClass}>{children}</div>
}

export default FormField
